// removed by extract-text-webpack-plugin
module.exports = {"matrix":"_6pVK","combo":"_1Ekf"};


//////////////////
// WEBPACK FOOTER
// ./src/components/matrix/index.less
// module id = 248
// module chunks = 0